import { IIoCContainer } from '@lmnop/web-core';
import { CoreModulesIoC } from './core-modules-ioc.class';
import { IWebsiteCoreSettings } from 'website-core-src';

export interface IWebsiteCoreIoCContainer extends IIoCContainer {
    core: CoreModulesIoC;
    settings: IWebsiteCoreSettings;
}
